import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { Row, Col } from 'antd'
import { get } from 'lodash'
import { translate } from 'react-i18next'
import { IconHelper } from '../../helpers'

const ContentDetail = ({ reservationContent, t }) => {
    const id = get(reservationContent, '[0]id', '')
    const name = get(reservationContent, '[0]name', '')
    const password = get(reservationContent, '[0]password', '')
    const moderators = get(reservationContent, '[0].moderators', '')
    const detail = get(reservationContent, '[0].detail', '')
    const startDate = moment(get(reservationContent, '[0]start_dt', '')).format('D/MM/YYYY HH:mm')
    const endDate = moment(get(reservationContent, '[0]end_dt', '')).format('D/MM/YYYY HH:mm')
    const [showPass, setshowPass] = useState(false)
    const { IconEye } = IconHelper

    useEffect(() => {
        setshowPass(false)
    }, [id])

    return (
        <>
            <div className="copy-detail">
                <Row className="reservation-main-detail">
                    <Col span={6} className="reservation-title">{t("reservation_detail.url")}</Col>
                    <Col span={16} className="reservation-detail">{`${window._env_.vRoomUrl}/${name}`}</Col>
                </Row>
                <Row className="reservation-main-detail">
                    <Col span={6} className="reservation-title">{t("reservation_detail.password")}</Col>
                    <Col span={16} className="reservation-detail">
                        {
                            password ? (showPass ? password : `********`) : null
                        }
                        {password ? <IconEye
                            style={{
                                cursor: "pointer",
                                verticalAlign: showPass ? "middle" : "baseline",
                                marginLeft: "15px"
                            }}
                            onClick={() => setshowPass(!showPass)}
                        /> : null}
                    </Col>
                </Row>
                <Row className="reservation-main-detail">
                    <Col span={6} className="reservation-title">{t("reservation_detail.date")}</Col>
                    <Col span={16} className="reservation-detail">{startDate}</Col>
                </Row>
                <Row className="reservation-main-detail">
                    <Col span={6} className="reservation-title">{t("reservation_detail.time")}</Col>
                    <Col span={16} className="reservation-detail">{endDate}</Col>
                </Row>
                <Row className="reservation-main-detail">
                    <Col span={6} className="reservation-title">{t("reservation_detail.moderator")}</Col>
                    <Col span={16} className="reservation-detail">{moderators.join(', ')}</Col>
                </Row>
                <Row className="reservation-main-detail">
                    <Col span={6} className="reservation-title">{t("reservation_detail.detail")}</Col>
                    <Col span={16} className="reservation-detail">
                        {detail}
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default translate()(ContentDetail)
